module.exports = __webpack_public_path__ + "media/images/refocus-2025-59cb582cb77fa0e9c40e7fcafdce904e.png";